import { FC, useContext } from "react";

import { FooterContext } from "src/context/footerContext";
import {AuthContext} from "../../context/authContext";

import { FAX_NUMBER, PHONE_NUMBER } from "../../constants/contact";
import { ContactAndSafetyInfoProps } from "./types";




const ContactAndSafetyInfo: FC<ContactAndSafetyInfoProps> = ({ alignText, textColor, isLogin = false }): JSX.Element => {
  const { isUserAuthorized } = useContext(AuthContext);
  const { changeAccordianVisibility } = useContext(FooterContext)

  return (
    <>
      {isUserAuthorized && (
        <div className={`${alignText} align-items-center`}>
          <button type="button" onClick={changeAccordianVisibility} className="btn btn-link">
            Important Safety Information
          </button>
          <span className={`text-${textColor}`}> | </span>
          <a
            href="https://afrezzahcp.com/wp-content/uploads/2026/01/Full-Prescribing-Information-Jan-2026.pdf" target="_blank"
            className="btn btn-link" rel="noreferrer"
          >
            Full Prescribing Information
          </a>
        </div>
      )}
      {isUserAuthorized && (
        <div className={`${alignText} mb-3`} data-tour="sixth-step">
            <p>Phone: {PHONE_NUMBER} | Fax: {FAX_NUMBER}</p>
        </div>
      )}
    </>
  );
};

export default ContactAndSafetyInfo;
